<template>
  <div>
    <div class="log-header flex justify-between items-center">
      <h4 class="flex items-center">
        <feather-icon
          icon="PhoneCallIcon"
          svgClasses="h-6 w-6"
        ></feather-icon>
        {{ $route.params.page == "order" ? $t("orderPhoneLog") : "" }}
      </h4>
    </div>
    <vs-divider class="m-0 mb-6" />
    <table class="w-full">
      <thead>
        <tr>
          <th>{{ $t('captainName') }}</th>
          <th>{{ $t('captainNumber') }}</th>
          <th>{{ $t('receiverNumber') }}</th>
          <th>{{ $t('callType') }}</th>
          <th>{{ $t('callStatus') }}</th>
          <th>{{ $t('callDuration') }}</th>
          <th>{{ $t('callDate') }}</th>
          <th>{{ $t('createdAt') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(log, index) in orderPhoneLogs" :key="index">
          <td>
            {{ log.captain.name }}
          </td>
          <td>
            {{ log.captain_phone }}
          </td>
          <td>
            {{ log.receiver_phone }}
          </td>
          <td>
            {{ log.type_text }}
          </td>
          <td>
            {{ log.status }}
          </td>
          <td>
            {{ log.duration }}
          </td>
          <td>
            {{ formatDate(log.call_date * 1000) }}
          </td>
          <td>
            {{ formatDate(log.created_at) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      orderPhoneLogs: []
    }
  },
  computed: {
    ...mapGetters('dataList', ['orderPhoneLog']),
  },
  methods: {
    ...mapActions('dataList', ['fetchOrderPhoneLog']),
    formatDate (date) {
      return new Date(date).toLocaleDateString('ar-EG', {
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  },
  async created () {
      await this.fetchOrderPhoneLog(this.$route.params.id)
      console.log(this.orderPhoneLog[0]);
      
      this.orderPhoneLogs = this.orderPhoneLog
  }
}
</script>

<style lang='scss' scoped>
@import "@/assets/scss/vuexy/_variables.scss";

.log-header {
  margin-bottom: 0.9375rem;
  h4 {
    color: #212121;
    font-size: 1.125rem;
    line-height: 2.9375rem;
    font-weight: bold;
  }
  .btn-log {
    display: flex;
    .add-log {
      font-family: "cairo";
      border: none;
      background-color: $mainColor2;
      border-radius: 0.3125rem;
      width: fit-content;
      padding: 0rem 0.75rem;
      height: 2.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $mainColor1;
      margin-left: 1.5rem;
      cursor: pointer;
      font-weight: 600;
    }
  }
}
.log-body {
  background-color: #ffffff;
  box-shadow: 0rem 0.25rem 0.25rem #0000000d;
  border-radius: 0.5rem;
  .log-body-header,
  .log-body-body {
    padding: 0.75rem 2.5rem;
    span {
      color: #212121;
      font-size: 0.875rem;
      line-height: 1.3125rem;
    }
    .icon-log {
      margin-right: 0.75rem;
      float: left;
      padding-top: 0.1875rem;
      width: 2rem;
      height: 2rem;
      background-color: #e9e9e9;
      border-radius: 50%;
      text-align: center;
      padding-top: 0.4375rem;
    }
  }
  .log-body-header {
    border-bottom: 0.0625rem solid rgba(0, 0, 0, 0.1);
    font-weight: 600;
  }
}

table {
  border-collapse: collapse;
  background-color: #fff;
  border-radius: 6px;
  thead {
    tr {
      th {
        text-align: left;
        border-bottom: 0.0625rem solid rgba(0, 0, 0, 0.1);
        padding: 0.75rem 2.5rem;
        &:first-child {
          border-top-left-radius: 6px;
        }
        &:last-child {
          border-top-right-radius: 6px;
        }
      }
    }
  }
  tbody {
    tr {
      td {
        text-align: left;
        padding: 0.75rem 2.5rem;
        font-size: 0.875rem;
      }
    }
  }
}
</style>
